import gql from 'graphql-tag'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { Query } from 'react-apollo'

import GenericPage from '../../sections/generic-page'

import { DooerComGetLatestToS } from './__generated__/DooerComGetLatestToS'
import Seo from '../../components/seo'

const getLatestToS = gql`
  query DooerComGetLatestToS {
    latestTermsOfService {
      id
      markdownContent {
        html
      }
    }
  }
`

const Tos = () => {
  return (
    <>
      <Seo
        description="Allmänna villkor"
        image="https://www.dooer.com/images/og/og_index.jpg"
        title="Allmänna villkor | Dooer"
        url="https://www.dooer.com/tos"
      />

      <GenericPage
        ledeText={
          <FormattedMessage
            defaultMessage="Innan ni börjar använda någon av våra tjänster behöver ni godkänna våra allmänna&nbsp;villkor. Tillsammans med uppdragsbekräftelsen efter godkänd offert utgör&nbsp;dessa en&nbsp;del&nbsp;av&nbsp;avtalet mellan ditt företag och oss."
            id="tos.lede"
          />
        }
        titleText={
          <FormattedMessage
            defaultMessage="Våra allmänna villkor berättar vem som ansvarar för&nbsp;vad."
            id="tos.title"
          />
        }
      >
        <Query<DooerComGetLatestToS> query={getLatestToS}>
          {({ data, error, loading }) =>
            error ? (
              <FormattedMessage
                defaultMessage="Något gick fel när vi försökte hämta våra villkor. Vänligen försök igen."
                id="tos.error"
              />
            ) : loading || !data ? (
              <FormattedMessage defaultMessage="Laddar våra villkor…" id="tos.loading" />
            ) : data && data.latestTermsOfService ? (
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: data.latestTermsOfService.markdownContent.html,
                }}
              />
            ) : null
          }
        </Query>
      </GenericPage>
    </>
  )
}

export default Tos
